<template>
  <div data-v-5fea6048="" data-v-2ac6a5fc="" class="addMethod">
    <!-- 主内容区：白色卡片布局，与添加银行卡页面一致 -->
    <div data-v-5fea6048="" class="content">
      <!-- 表单区域 -->
      <div data-v-5fea6048="" class="form-container">
        <!-- 钱包协议选择（ERC20/TRC20） -->
        <div data-v-5fea6048="" class="form-group">
          <label data-v-5fea6048="" for="walletProtocol" class="form-label">钱包协议</label>
          <div data-v-5fea6048="" class="form-input-group">
            <!-- 模拟下拉输入框外观 -->
            <input 
              data-v-5fea6048="" 
              v-model="meyXi" 
              readonly 
              type="text" 
              placeholder="请选择钱包协议" 
              class="form-input"
            />
            <!-- 实际下拉选择器（视觉隐藏） -->
            <select 
              data-v-5fea6048="" 
              id="walletProtocol" 
              v-model="meyXi" 
              class="select-input"
              @change="syncProtocolInput"
            >
              <option data-v-5fea6048="" value="TRC20">TRC20</option>
			  <option data-v-5fea6048="" value="ERC20">ERC20</option>
            </select>
            <!-- 下拉箭头图标 -->
            <span data-v-5fea6048="" class="arrow-icon"><i class="fas fa-chevron-down"></i></span>
            <!-- 错误提示（默认隐藏） -->
            <div data-v-5fea6048="" class="error-message" style="display: none"></div>
          </div>
        </div>

        <!-- 钱包地址输入 -->
        <div data-v-5fea6048="" class="form-group">
          <label data-v-5fea6048="" for="walletAddress" class="form-label">钱包地址</label>
          <div data-v-5fea6048="" :class="['form-input-group', { 'input-error': isAddressError }]">
            <input 
              data-v-5fea6048="" 
              id="walletAddress" 
              v-model="usdss" 
              type="text" 
              placeholder="请输入USDT钱包地址" 
              class="form-input"
              @blur="checkAddress"
              maxlength="64"
            />
            <!-- 错误提示（根据验证结果显示） -->
            <div data-v-5fea6048="" class="error-message" :style="{ display: isAddressError ? 'block' : 'none' }">
              请输入有效的USDT钱包地址
            </div>
          </div>
          <!-- 辅助提示：区分ERC20/TRC20地址格式差异 -->
          <p class="helper-tip">
            提示：ERC20地址以"0x"开头，TRC20地址以"T"开头，请确认协议与地址匹配
          </p>
        </div>

        <!-- 支付密码输入 -->
        <div data-v-5fea6048="" class="form-group">
          <label data-v-5fea6048="" for="payPassword" class="form-label">支付密码</label>
          <div data-v-5fea6048="" :class="['form-input-group', { 'input-error': isPayPassError }]">
            <input 
              data-v-5fea6048="" 
              id="payPassword" 
              type="password" 
              v-model="pay_pass" 
              placeholder="请输入支付密码" 
              class="form-input"
              @blur="checkPayPass"
              maxlength="18"
            />
            <!-- 错误提示（根据验证结果显示） -->
            <div data-v-5fea6048="" class="error-message" :style="{ display: isPayPassError ? 'block' : 'none' }">
              支付密码长度为6-18位
            </div>
          </div>
        </div>
      </div>

      <!-- 保存按钮 -->
      <div data-v-5fea6048="" class="button-wrapper">
        <button 
          data-v-5fea6048="" 
          class="submit-btn" 
          @click="bindUsdss"
          :disabled="isSubmitting"
        >
          <span v-if="!isSubmitting">保存</span>
          <span v-if="isSubmitting"><i class="fas fa-spinner fa-spin"></i> 提交中...</span>
        </button>
      </div>

      <!-- 客服提示 -->
      <p data-v-5fea6048="" class="add-error-tips">
        无法绑定？
        <span data-v-5fea6048="" @click="$parent.openKefu" class="contact-kefu">联系客服</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'addUsdtCard', // 修正组件名，与功能匹配
  data() {
    return {
      baseURL: '',
      meyXi: 'TRC20', // 钱包协议（默认选中TRC20）
      usdss: '', // 钱包地址
      pay_pass: '', // 支付密码
      // 表单验证状态
      isAddressError: false,
      isPayPassError: false,
      // 提交状态（防止重复点击）
      isSubmitting: false
    };
  },
  created() {
    this.baseURL = sessionStorage.getItem('baseURL') || '';
  },
  methods: {
    // 同步下拉选择值到输入框（确保显示选中的协议）
    syncProtocolInput() {
      this.meyXi = this.meyXi; // 触发v-model更新
    },

    // 表单验证：钱包地址（基础格式校验）
    checkAddress() {
      const address = this.usdss.trim();
      // 简单校验：ERC20以0x开头（42位），TRC20以T开头（34位）
      const isErc20Valid = this.meyXi === 'ERC20' && /^0x[0-9a-fA-F]{40}$/.test(address);
      const isTrc20Valid = this.meyXi === 'TRC20' && /^T[0-9a-zA-Z]{33}$/.test(address);
      
      // 未输入或格式不匹配则提示错误
      this.isAddressError = address === '' || !(isErc20Valid || isTrc20Valid);
    },

    // 表单验证：支付密码
    checkPayPass() {
      this.isPayPassError = this.pay_pass.length < 6 || this.pay_pass.length > 18;
    },

    // 提交绑定USDT钱包（保留原接口逻辑，优化验证流程）
    bindUsdss() {
      // 先执行全量验证
      this.checkAddress();
      this.checkPayPass();

      // 若存在验证错误，不提交
      if (this.isAddressError || this.isPayPassError) {
        this.$parent.showTost(0, '请完善并核对表单信息');
        return;
      }

      // 提交中状态锁定
      this.isSubmitting = true;
      this.$parent.showLoading();

      // 构造请求参数（与原逻辑一致，bank固定为USDT）
      const params = {
        bank: 'USDT',
        bank_no: this.usdss.trim(),
        bank_owner: this.meyXi, // 此处bank_owner传递协议类型，与原接口保持一致
        pay_pass: this.pay_pass
      };

      this.$apiFun.post('/api/bindcard', params).then(res => {
        this.$parent.hideLoading();
        this.isSubmitting = false;

        if (res.code !== 200) {
          this.$parent.showTost(0, res.message || '绑定失败，请重试');
          return;
        }

        // 绑定成功：提示+返回上一页
        this.$parent.showTost(1, '添加成功！');
        setTimeout(() => {
          this.$router.back();
        }, 1500);
      }).catch(() => {
        this.$parent.hideLoading();
        this.isSubmitting = false;
        this.$parent.showTost(0, '网络异常，提交失败');
      });
    },

    // 移除冗余的bindCard方法（原银行卡绑定逻辑，当前页面无用）
    bindCard() {}
  }
};
</script>

<style lang="scss" scoped>
// 复用首页基础变量，确保风格统一
$white: #ffffff;
$light-gray: #f9fafb;
$border-gray: #e5e7eb;
$accent: #165DFF; // 首页主题色
$error-red: #FF4D4F; // 错误提示色
$text-dark: #1f2937; // 深色文字
$text-gray: #4b5563; // 灰色文字
$text-light-gray: #9ca3af; // 浅灰色文字（辅助提示）
$transition: all 0.3s ease;
$radius: 8px; // 圆角（与首页一致）

// 页面容器：与添加银行卡页面完全一致
.addMethod {
  width: 100%;
  min-height: calc(100vh - 110px); // 减去顶部(50px)+底部(60px)导航高度
  background: $light-gray;
  padding: 20px 16px;
  box-sizing: border-box;
}

// 表单卡片：白色背景+阴影，与添加银行卡页面统一
.content {
  max-width: 500px;
  margin: 0 auto;
  background: $white;
  border-radius: $radius;
  padding: 24px 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

// 表单容器：统一间距
.form-container {
  margin-bottom: 30px;
}

// 表单组：垂直间距
.form-group {
  margin-bottom: 20px;
}

// 表单标签：与添加银行卡页面一致
.form-label {
  display: block;
  font-size: 14px;
  color: $text-dark;
  margin-bottom: 6px;
  font-weight: 500;
}

// 表单输入组：包含输入框、图标、错误提示
.form-input-group {
  position: relative;
  width: 100%;

  // 错误状态样式（与添加银行卡页面统一）
  &.input-error {
    .form-input {
      border-color: $error-red;
      &:focus {
        border-color: $error-red;
        box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
      }
    }
  }
}

// 表单输入框：样式与添加银行卡页面完全一致
.form-input {
  width: 100%;
  height: 44px;
  padding: 0 14px;
  padding-right: 36px; // 为下拉箭头预留空间
  background: $white;
  border: 1px solid $border-gray;
  border-radius: $radius;
  font-size: 14px;
  color: $text-dark;
  box-sizing: border-box;
  transition: $transition;

  // 聚焦状态：主题色边框
  &:focus {
    outline: none;
    border-color: $accent;
    box-shadow: 0 0 0 2px rgba(22, 93, 255, 0.2);
  }

  // 只读状态（协议选择框）
  &[readonly] {
    cursor: pointer;
    background: $light-gray;
    color: $text-gray;
  }

  // 占位符样式
  &::placeholder {
    color: $text-light-gray;
    font-size: 13px;
  }
}

// 下拉选择器：视觉隐藏，仅保留功能
.select-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 1;
}

// 下拉箭头图标：与添加银行卡页面一致
.arrow-icon {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: $text-light-gray;
  font-size: 12px;
  z-index: 0;
}

// 错误提示：样式统一
.error-message {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  font-size: 12px;
  color: $error-red;
  line-height: 1.4;
}

// 辅助提示（钱包地址格式说明）：浅灰色小文字
.helper-tip {
  margin: 25px 0 0 0;
  font-size: 12px;
  color: $text-light-gray;
  line-height: 1.5;
  padding-left: 2px;
}

// 提交按钮：与添加银行卡页面/首页按钮风格统一
.submit-btn {
  width: 100%;
  height: 46px;
  background: $accent;
  color: $white;
  border: none;
  border-radius: $radius;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: $transition;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  // 禁用/加载状态
  &:disabled {
    background: #84A9FF;
    cursor: not-allowed;
    transform: none;
  }

  // hover效果
  &:not(:disabled):hover {
    background: #0E42C3;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(22, 93, 255, 0.2);
  }
}

// 按钮容器：统一间距
.button-wrapper {
  margin-bottom: 20px;
}

// 客服提示文字：与添加银行卡页面一致
.add-error-tips {
  margin: 0;
  text-align: center;
  font-size: 13px;
  color: $text-gray;
  line-height: 1.6;

  .contact-kefu {
    color: $accent;
    cursor: pointer;
    font-weight: 500;
    &:hover {
      text-decoration: underline;
    }
  }
}

// 移动端适配：与添加银行卡页面同步
@media (max-width: 375px) {
  .content {
    padding: 20px 14px;
  }

  .form-input {
    height: 42px;
  }

  .submit-btn {
    height: 44px;
    font-size: 15px;
  }

  .helper-tip {
    font-size: 11px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/main/addUsdtCard.vue